export const minCodePanelWidth = 500;

export const actions = {
  NEW_SAVE_COMPLETE: 1,
  SAVE_COMPLETE: 2,
  CONFIRMATION_DIALOG_OPEN: 3,
  CONFIRMATION_DIALOG_CLOSE: 4,
  UPDATE_CODE_PANEL_WIDTH: 5,
  UPDATE_MODIFIED: 6,
  TOGGLE_GRAPH_PANEL: 7,
  SAVE_COMPLETE_CLOSE: 8,
  SAVE_CONFIRMATION_CLOSE: 9,
  SAVE_CONFIRMATION_OPEN: 10,
};


export const initialState = {
  inputParameters: [],
  outputParameters: {},
  restartable: false,
  timeoutPolicy: "",
  timeoutSeconds: 0,
  failureWorkflow: "",
};
export const DEFAULT_SPLIT_SIZES = [50, 50];
export const DEFAULT_SPLIT_MIN_SIZES = [0, 500];
export const DEFAULT_SPLIT_MAX_SIZES = [Infinity, 800];
export const DEFAULT_GUTTER_SIZE = 10;
export const DEFAULT_TAB_VALUE = 0;
export const DEFAULT_DPR = 1;
export const EDITOR_DEBOUNCE_DELAY = 4000;
export const NODE_CLICK_LOADING_DELAY = 800;
export const TASK_CREATION_DELAY = 500;


export const SECONDS_IN_DAY = 24 * 3600;
export const SECONDS_IN_HOUR = 3600;
export const SECONDS_IN_MINUTE = 60;

